export default "__VITE_ASSET__BvuRnR$v__"